export default __webpack_public_path__ + "locales/pt/PortalUnavailable.json?hash=2e89375b71f021aeda1b5bd108898221";